// NOME PÚBLICO da imobiliária (SD-0020, cs1859 Mister Imóveis — 14/10/2026).
//
// `Dados.empresa` vem de `tbl_clientes.Empresa` = RAZÃO SOCIAL ("Vidoti e Apolinario Negocios
// Imobiliarios Ltda"). O site usava isso em TODO texto público (mensagem do WhatsApp, "Anuncie seu
// Imóvel", rodapé, alt/title do logo, JSON-LD) — 111 dos 224 sites ativos têm nome fantasia
// diferente da razão social e mostravam a razão social ao visitante.
//
// Regra aprovada (Daniel): nome público = `nome_fantasia` (com trim); vazio → cai em `empresa`.
// A razão social continua disponível em `Dados.razao_social` para uso FISCAL (CNPJ, contrato).
// Nenhum uso de `Dados.empresa` no front era fiscal (CRECI usa `Dados.creci`), então a troca é
// feita UMA vez, na carga do site (services/home.ts), e vale para os ~160 pontos de uso.

export const nomePublico = (dados: any): string => {
  const fantasia = String(dados?.nome_fantasia ?? '').trim();
  return fantasia || dados?.empresa;
};

// Idempotente: payload que já passou por aqui (cache Redis `ssr:site:*`) tem `razao_social` e não
// é reprocessado — senão a 2ª passada apagaria a razão social (empresa já seria a fantasia).
export const aplicaNomePublico = <T extends { Dados?: any } | null | undefined>(site: T): T => {
  const dados = (site as any)?.Dados;
  if (!dados || typeof dados !== 'object') return site;
  if (Object.prototype.hasOwnProperty.call(dados, 'razao_social')) return site;
  return {
    ...(site as any),
    Dados: { ...dados, razao_social: dados.empresa ?? null, empresa: nomePublico(dados) },
  } as T;
};
